/**
 * Archivo para manejar formatos de fechas
 */
export const DATE_FORMAT_MYSQL = 'YYYY/MM/DD';
export const DATE_FORMAT_STANDAR = 'DD/MM/YYYY';

export const DATETIME_FORMAT_MYSQL = 'YYYY/MM/DD HH:mm:ss';
export const DATETIME_FORMAT_STANDAR = 'DD/MM/YYYY HH:mm:ss';
export const DATETIME_FORMAT_NO_SECONDS = 'DD/MM/YYYY HH:mm';